import { render, staticRenderFns } from "./SearchProduct.vue?vue&type=template&id=54a85da2&scoped=true"
import script from "./SearchProduct.vue?vue&type=script&lang=js"
export * from "./SearchProduct.vue?vue&type=script&lang=js"
import style0 from "./SearchProduct.vue?vue&type=style&index=0&id=54a85da2&prod&lang=scss&scoped=true"
import style1 from "./SearchProduct.vue?vue&type=style&index=1&id=54a85da2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a85da2",
  null
  
)

export default component.exports